/**
 * Display form of a coupon rejection message from the API.
 *
 * ## Invariants:
 * - Shared by the hourly/event booking (`reserve.store`) and the zone / touchless ticket flows
 *   (`qr.store`). Why: both show the API's own reason for rejecting a code ("Coupon's daily usage
 *   limit has been exceeded for the day."), and a copy per store is how one of them ends up
 *   shouting a message the other has already tidied (PB-5005).
 * - Only the shouted invalid-coupon phrase is rewritten; every other message passes through
 *   as-is. Why: the API shouts "This coupon is NOT VALID/APPLICABLE", which design wants in
 *   sentence case (PB-4346), but the remaining messages are already parker-facing copy.
 */
export const normalizeCouponErrorMessage = (message: string): string =>
  message.replace('NOT VALID/APPLICABLE', 'not valid/applicable');
